import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78d6e414"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ant-row",
  style: {"max-height":"100%","height":"100%","overflow-y":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "ant-col ant-col-xs-5 ant-col-xl-5 ss-div-cifrao"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ss-texto-cifrao" }, "R$", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "ant-col ss-div-valor"
}
const _hoisted_6 = { class: "ss-texto-valor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.props.widget.valoresMonetarios)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.props.widget.dados.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.props.widget.dados[0].valor,
        _ctx.props.widget.dados[0].casasDecimais)), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}